<template>
  <router-link
    :class="notificationClasses"
    :to="notification.link"
    @click.native="handleNotificationClick"
  >
    <article class="notification__body">
      <header class="notification__header">
        <h2 class="notification__title">
          {{ notification.summary }}
        </h2>
        <div
          class="notification__date"
          :class="{ 'notification__date--unread': isUnread }"
        >
          {{ formatTimeAgo(notification.created_at) }}
        </div>
        <span
          :class="markAsReadClasses"
          :title="t('notifications.markAsRead')"
          @click.capture.stop.prevent="markAsRead()"
        ></span>
      </header>
      {{ notification.body }}
    </article>
  </router-link>
</template>

<script>
  import { useStrings } from '@/composables/useStrings.ts'
  import { useDate } from '@/composables/useDate'
  import { useAppStore } from '@/stores/useAppStore';
  import { useCubeStore } from '@/stores/useCubeStore';

  export default {
    name: 'notification',
    setup(){
      const appStore = useAppStore()
      const cubeStore = useCubeStore()
      const { t } = useStrings()
      const { formatTimeAgo } = useDate()

      return{
        t,
        appStore,
        cubeStore,
        formatTimeAgo,
      }
    },
    props: {
      notification: {
        type: Object,
        required: true,
      },
    },
    computed: {
      notificationClasses() {
        let result = ['notification']
        if (this.isUnread) {
          result.push('notification--unread')
        }
        return result.join(' ')
      },
      markAsReadClasses() {
        let result = ['notification__mark-read']
        if (this.isUnread) {
          result.push('notification__mark-read--unread')
        }
        return result.join(' ')
      },
      isUnread() {
        return this.notification.unread === 1
      },
    },
    methods: {
      markAsRead() {
        if (this.isUnread) {
          this.cubeStore.markNotificationsAsRead({
            notification: this.notification,
          })
          return false
        }
      },
      handleNotificationClick() {
        this.markAsRead()
        this.appStore.showSlidein('notifications', false)
      },
    },
  }
</script>

<style lang="scss">
  .notification {
    display: flex;
    padding: $spacer10 0;
    transition: $transition-base;
    align-items: center;

    &:hover,
    &:active,
    &:focus {
      color: $grey-dark;
    }

    &__img {
      max-width: 50px;
      width: 50px;
      margin-right: $spacer10;
      flex-grow: 0;
      flex-shrink: 0;
    }

    &__header {
      display: flex;
      align-items: baseline;
      margin-bottom: $spacer05;
      line-height: $line-height-sm;
    }

    &__title {
      flex-grow: 1;
      margin-bottom: 0;
      font-size: 1.2rem;
    }

    &__body {
      flex-grow: 1;
    }

    &__date {
      white-space: nowrap;
      margin-left: $spacer10;
      font-weight: normal;
      font-size: $font-size-sm;

      &--unread {
        font-weight: $font-weight-bold;
      }
    }

    &__mark-read {
      transition: $transition-base;
      width: $notification-dot-size;
      height: $notification-dot-size;
      border-radius: 100%;
      flex-shrink: 0;
      margin-left: $spacer075;
      background: $notification-color;
      display: inline-block;
      opacity: 0;
      transform: translateY(10%);

      &--unread {
        opacity: 1;
      }
    }
  }
</style>
